import { combineReducers } from 'redux-immutable'

import TourReducer from 'aria-viewer/tour/tourReducer'
import ConfigReducer from 'aria-viewer/config/configReducer'
import ContextMenuReducer from 'aria-viewer/contextmenu/contextMenuReducer'
import LanguageReducer from 'aria-viewer/language/languageReducer'
import StopCardsReducer from 'aria-viewer/stopselector/reducers/stopCards'
import ModalReducer from 'aria-viewer/modal/modalReducer'
import DrawerMenuReducer from 'aria-viewer/drawer/drawerMenuReducer'
import SupplementalMediaReducer from 'aria-viewer/players/supplementalmedia/supplementalMediaReducer'
import SlidePanelReducer from 'aria-viewer/slidepanel/slidePanelReducer'
import NavigationReducer from 'aria-viewer/navigation/navigationReducer'
import AudioManagerReducer from 'aria-viewer/audiomanager/audioManagerReducer'
import { VideoPlayerReducer } from 'aria-viewer/players/videoplayer'
import PanoramaReducer from 'aria-viewer/players/panoplayer/reducers/panorama'
import MapReducer from 'aria-viewer/map/mapReducer'
import MetaReducer from 'aria-viewer/metamodels/metaModelReducer'
import AnalyticsReducer from 'aria-viewer/analytics/analyticsReducer'
import DeviceReducer from 'aria-viewer/device/deviceReducer'
import RegistrationReducer from 'aria-viewer/registration/registrationReducer'
import InteractiveElementsReducer from 'aria-viewer/interactive-element/interactiveElementsReducer'
import { reducer as StatsReducer } from 'aria-viewer/stats'

import { reducer as CTAPromptReducer } from 'aria-viewer/ctaPrompt'
import { routerReducer } from 'react-router-redux'
import { PaymentReducer } from 'aria-viewer/payments'

import StopDescriptionReducer from 'aria-viewer/stopselector/reducers/stopDescriptionReducer'
import AvatarReducer from 'aria-viewer/guide/avatarReducer'

const rootReducer = combineReducers({
    routing: routerReducer,
    tour: TourReducer,
    config: ConfigReducer,
    contextMenu: ContextMenuReducer,
    device: DeviceReducer,
    language: LanguageReducer,
    modal: ModalReducer,
    stopCards: StopCardsReducer,
    stopDescription: StopDescriptionReducer,
    drawerMenu: DrawerMenuReducer,
    supplementalMedia: SupplementalMediaReducer,
    slidePanel: SlidePanelReducer,
    navigation: NavigationReducer,
    audioManager: AudioManagerReducer,
    video: VideoPlayerReducer,
    panorama: PanoramaReducer,
    map: MapReducer,
    meta: MetaReducer,
    analytics: AnalyticsReducer,
    interactiveElements: InteractiveElementsReducer,
    payments: PaymentReducer,
    registration: RegistrationReducer,
    ctaPrompt: CTAPromptReducer,
    avatar: AvatarReducer,
    stats: StatsReducer,
})

export default rootReducer
